var cov_148ejchrwh = function () {
  var path = "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/analytics/analyticsCtrl.js",
      hash = "29f0207d8894813a2b201941bf77e163579979af",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/analytics/analyticsCtrl.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();